const UserRole = {
  LH_SUPPORT: "LH_SUPPORT",
  OWNER: "OWNER",
  ADMIN: "ADMIN",
  MANAGER: "MANAGER",
  HR: "HR",
  DISPATCHER: "DISPATCHER",
  ACCOUNTANT: "ACCOUNTANT",
} as const;

type UserRole = (typeof UserRole)[keyof typeof UserRole];

export default UserRole;
export type { UserRole };
